module.exports = __webpack_public_path__ + "img/6.e6e8642f.jpg";